/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import isArray from 'lodash/isArray';
import isBoolean from 'lodash/isBoolean';
import isObject from 'lodash/isObject';
import isObjectLike from 'lodash/isObjectLike';

import HolidayInterval from './holiday-interval';

/**
 * @private
 * @typedef {import('../json').JSONObject} JSONObject
 * @typedef {import('../logger/logger').Logger} Logger
 */

/**
 * @typedef {{
 *   start: string;
 *   end: string;
 *   repeatYearly: boolean;
 * } & JSONObject} HolidayIntervalJson
 */

/**
 * @typedef {{
 *   intervals: HolidayIntervalJson[];
 * } & JSONObject} HolidayJson Prázdninový plán ze serveru.
 *
 * Parsujeme jen pro nás zajímavé hodnoty a ostatní, které chodí, ignorujeme.
 */

// TODO: Nebo spíše HolidayIntervalParser, tj. název po výstupním typu?
/**
 * Parser prázdnin pro Ki-Wi Server.
 */
class HolidayParser {
  /**
   * Naparsuje prázdniny ze serveru.
   * @param {Logger} logger Logger pro zaznamenávání chyb.
   * @param {HolidayJson[]} jsonArray
   * @returns {HolidayInterval[]}
   */
  static parseMany(logger, jsonArray) {
    return jsonArray.flatMap((json) => {
      // Preskakovanie nevalidných prázdnin
      try {
        return this.parseOne(json);
      } catch (error) {
        logger.error(error);
        return [];
      }
    });
  }

  /**
   * Naparsuje seznam prázdninnových intervalů z JSONu prázdnin.
   * @param {HolidayJson} json Část odpovědi ze serveru pro prázdniny.
   * @returns {HolidayInterval[]}
   * @throws {TypeError}
   */
  static parseOne(json) {
    let cause;
    try {
      if (
        // TODO #555: Type guard nefunguje, proto zbytečná zdvojená kontrola.
        isObject(json) &&
        isObjectLike(json) &&
        isArray(json.intervals) &&
        // HolidayInterval.fromObject má volitelné repeatYearly,
        // tak je nutné zkontrolovat explicitně zde.
        json.intervals.every((interval) => isBoolean(interval.repeatYearly))
      ) {
        return json.intervals.map(HolidayInterval.fromObject);
      }
    } catch (error) {
      cause = error;
    }
    // Schválně mimo catch, aby se jednotně ošetřilo nesplnění
    // vstupních podmínek i případná vyhozená chyba.
    throw new TypeError(`parsing holiday ${JSON.stringify(json)}`, { cause });
  }
}

export default HolidayParser;
